import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import swal from "sweetalert2";

import { Data } from 'src/app/models/data';
import { ProviderCategory } from 'src/app/models/providerCategory';
import { ProviderService } from 'src/app/services/provider.service';
import { UtilsService } from 'src/app/services/utils.service';
import { AccessService } from '../../../services/access.service';

@Component({
  selector: 'app-provider-category',
  templateUrl: './provider-category.component.html',
  styleUrls: ['../../../app.component.scss'],
  providers: [UtilsService, ProviderService, AccessService]
})

export class ProviderCategoryComponent implements OnInit {
  @ViewChild('formulario') formulario!: NgForm;

  // MODELS VARIABLE 
  public providerCategory = {} as ProviderCategory;
  public data = {} as Data;
  public isEdit: boolean = false;
  public loading: boolean = false;
  public isDisabled: boolean = false;
  public userCode: number;
  public companyCode: number;

  // VARIABLE FOR DATA TABLE
  public temp = [];
  public activeRow: any;
  public entries: number = 10;
  public selected: any[] = [];
  public providerCategoryList = new Array();
  public test: any = `<button (click)="onSelect($event)">Click me</button>`;

  constructor(
    private _utilsService: UtilsService,
    private _accessService: AccessService,
    private _providerService: ProviderService,
  ) { }

  ngOnInit() {
    // GET ID USER & ID COMPANY    
    const _user = JSON.parse(localStorage.getItem('user'));
    this.data.companyCode = _user.userCompany ? parseInt(_user.userCompany.toString()) : 0;
    this.data.userCode = _user.userCode ? parseInt(_user.userCode.toString()) : 0;

    // LOAD INFORMATION
    this.getAll();
  }

  ///////////////////////FUNCTION FOR TABLE///////////////////////
  entriesChange($event) {
    this.entries = $event.target.value;
  }

  filterTable($event) {
    let val = $event.target.value.toLowerCase();
    this.temp = this.providerCategoryList.filter(function (d) {

      for (var key in d) {
        if (d[key] !== null) {
          if (d[key].toString().toLowerCase().indexOf(val) !== -1) {
            return true;
          }
        }
      }
      return false;
    });
  }

  onActivate(event) {
    this.activeRow = event.row;
  }

  ///////////////////////CRUD///////////////////////  
  // GET ALL COMPANY PLAN
  getAll() {
    this.loading = true;

    return this._providerService.getAllProviderCategory().then(
      response => {
        if (response.result) {
          this.providerCategoryList = response.records;
          this.temp = this.providerCategoryList;
        } else {
          console.log(response.message);
        }
      },
      error => {
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
    });
  }

  validate(type: number, name: string): boolean {
    switch (type) {
      case 1: return this.formulario?.controls[name]?.errors
        && this.formulario?.controls[name]?.touched;
        break;
      case 2: return this.formulario?.controls[name]?.invalid
        && this.formulario?.controls[name]?.touched;
        break;
      case 3: return this.formulario?.controls.precio?.touched
        && this.formulario?.controls.precio?.value < 0;
        break;
    }
  }

  // INSERT
  save() {
    if (this.formulario.valid) {
      this.isDisabled = true;
      this.loading = true;

      this.providerCategory.providerCategoryStatus = 1;
      this.providerCategory.providerCategoryDeleted = 0;

      this._providerService.insertProviderCategory(this.providerCategory).then(
        async (response) => {
          if (response.result == true) {
            this.getAll();
            this.cleanModel();
            this._utilsService.showNotification(1, response.message);
          } else {
            this._utilsService.showNotification(3, response.errorMessage);
          }
        },
        error => {
          this._utilsService.showNotification(2, error);
          console.log(error);
        }
      ).finally(() => {
        this.loading = false;
        this.isDisabled = false;
      });
    } else {
      this.formulario.control.markAllAsTouched();
      this._utilsService.showNotification(2, 'Falto llenar campos');
    }
  }

  // UPDATE
  update() {
    if (this.formulario.valid) {
    this.loading = true;
    this.isDisabled = true;
    
    this._providerService.updateProviderCategory(this.providerCategory).then(
      async (response) => {
        if (response.result == true) {
          this.getAll();
          this.cleanModel();
          this._utilsService.showNotification(1, response.message);
        } else {
          this._utilsService.showNotification(3, response.errorMessage);
        }
      },
      error => {
        this._utilsService.showNotification(2, error);
        console.log(error);
      }
    ).finally(() => {
      this.loading = false;
      this.isDisabled = false;
    });
  } else {
    this.formulario.control.markAllAsTouched();
    this._utilsService.showNotification(2, 'Falto llenar campos');
  }
}

  // DELETED
  async deleteFunction($event) {
    $event.preventDefault();

    this.providerCategory.providerCategoryStatus = 0;
    this.providerCategory.providerCategoryDeleted = 1;
    this.providerCategory.providerCategoryCode = this.activeRow.providerCategoryCode;
    this.providerCategory.providerCategoryName = this.activeRow.providerCategoryName;

    swal.fire({
      title: "Esta seguro",
      text: "El tipo de empresa se eliminara definitivamte!",
      icon: "warning",
      showCancelButton: true,
      customClass: {
        confirmButton: "btn btn-success",
        cancelButton: "btn btn-danger",
      },
      confirmButtonText: "Si, eliminar!",
      buttonsStyling: false
    }).then(result => {
      if (result.value) {
        this.update();
        swal.fire({
          title: "Enviado!",
          text: "Se ha mandado la solicitud.",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-success",
          },
          buttonsStyling: false
        });
      }
    });
  }

  // LOAD DATA TO EDIT
  editFunction($event) {
    $event.preventDefault();
    this.isEdit = true;

    this.providerCategory.providerCategoryStatus = 1;
    this.providerCategory.providerCategoryDeleted = 0;
    this.providerCategory.providerCategoryCode = this.activeRow.providerCategoryCode;
    this.providerCategory.providerCategoryName = this.activeRow.providerCategoryName;
  }

  ///////////////////////COMPLEMENT///////////////////////  
  // CLEAR MODAL
  cleanModel(cancel?: boolean) {
    //(!cancel) && this.getAll();
    this.isEdit = false;
    this.isDisabled = false;
    this.providerCategory = {} as ProviderCategory;
    this.formulario.resetForm();
  }
}
